import { Paper, ToggleButtonGroup, ToggleButton, Box, Divider } from '@mui/material'
import { ViewList, Map as MapIcon, FilterList } from '@mui/icons-material'

interface ViewModeToggleProps {
  viewMode: 'grid' | 'map'
  onChange: (mode: 'grid' | 'map') => void
  onFilterClick?: () => void
}

export function ViewModeToggle({ viewMode, onChange, onFilterClick }: ViewModeToggleProps) {
  return (
    <Paper
      elevation={2}
      sx={{
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 1000,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <ToggleButtonGroup
        orientation="vertical"
        value={viewMode}
        exclusive
        onChange={(_, newMode) => newMode && onChange(newMode)}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            border: 'none',
            width: '30px',
            height: '30px',
            minWidth: '30px',
            padding: 0,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          },
        }}
      >
        <ToggleButton value="map" aria-label="map view">
          <MapIcon fontSize="small" sx={{ fontSize: '18px' }} />
        </ToggleButton>
        <ToggleButton value="grid" aria-label="grid view">
          <ViewList fontSize="small" sx={{ fontSize: '18px' }} />
        </ToggleButton>
      </ToggleButtonGroup>

      {/* Filter button - always shown */}
      {onFilterClick && (
        <>
          <Divider sx={{ width: '100%', my: 0 }} />
          <Box
            onClick={onFilterClick}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '30px',
              height: '30px',
              cursor: 'pointer',
              color: 'action.active',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
            aria-label="open filters"
          >
            <FilterList fontSize="small" sx={{ fontSize: '18px' }} />
          </Box>
        </>
      )}
    </Paper>
  )
}
